// extracted by mini-css-extract-plugin
export default {"Layout":"user_Layout__UXscZ","Layout__tabs":"user_Layout__tabs__LpXDI"};